import {useIntl} from 'react-intl';

// What a list table needs for the refreshed look: the `table-v2` class that
// scopes its styles and a translated "Showing 1–10 of 57" for its
// pagination. (No sticky head: antd's sticky head fixes the column widths
// from the rows, which crops the column titles.)
const useTableV2 = () => {
  const {formatMessage} = useIntl();
  return {
    className: 'table-v2',
    showTotal: (total: number, range: [number, number]) =>
      formatMessage(
        {id: 'common.showingRange'},
        {from: range[0], to: range[1], total},
      ),
  };
};

export default useTableV2;
